export const PERMISOS_CACHE_PREFIX = 'permisosGranted';

export const ALWAYS_ALLOWED_PATHS = new Set(['/', '/menu-principal', '/acceso-denegado']);

const PATH_KEY_OVERRIDES: Record<string, string> = {
  '/dashboard': 'indicadores',
  '/inventario/fashion': 'fashion',
};

function normalizePath(pathname: string): string {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
}

export function pathToPermissionKey(pathname: string): string {
  const path = normalizePath(pathname.split('?')[0] || '/');
  if (PATH_KEY_OVERRIDES[path]) return PATH_KEY_OVERRIDES[path];
  if (path === '/inventario/fashion' || path.startsWith('/inventario/fashion/')) {
    const rest = path.slice('/inventario/fashion'.length).replace(/^\//, '');
    return rest ? `fashion.${rest.replace(/\//g, '.')}` : 'fashion';
  }
  return path.replace(/^\//, '').replace(/\//g, '.');
}

export function permisosCacheKey(username: string, tenantId: number | null): string {
  return `${PERMISOS_CACHE_PREFIX}:${tenantId ?? 0}:${username.trim().toLowerCase()}`;
}

export function clearPermisosCache(): void {
  if (typeof window === 'undefined') return;
  const toRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key && (key === PERMISOS_CACHE_PREFIX || key.startsWith(`${PERMISOS_CACHE_PREFIX}:`))) {
      toRemove.push(key);
    }
  }
  toRemove.forEach((key) => localStorage.removeItem(key));
}

export function readPermisosCache(username: string, tenantId: number | null): string[] | null {
  if (typeof window === 'undefined' || !username) return null;
  try {
    const raw = localStorage.getItem(permisosCacheKey(username, tenantId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? parsed.filter((k): k is string => typeof k === 'string') : null;
  } catch {
    return null;
  }
}

export function writePermisosCache(username: string, tenantId: number | null, granted: string[]): void {
  if (typeof window === 'undefined' || !username) return;
  try {
    localStorage.setItem(permisosCacheKey(username, tenantId), JSON.stringify(granted));
  } catch {
    /* quota */
  }
}
